import React, { Component } from 'react'
import { connect } from 'react-redux'

import scrollActions from 'actions/actionbar'
import { scrollTop } from 'selectors/common'
import { shouldScroll } from 'selectors/common'

let select = (state, props) => ({
	scrollTop: scrollTop(state, 'dashboardPropertyForm')
  , shouldScroll: shouldScroll(state)
})

export class Scroll extends Component{
	componentDidMount() {
		if (this.props.shouldScroll) {
			document.getElementsByClassName(`dashboardPropertyForm`)[0].scrollTop = this.props.scrollTop;
		}
	}
	render(){
		let { props } = this
		return(
			<div className={props.name} key={props.key}
				style={props.style}
				onScroll={(e)=>{this.props.SCROLL({scrollTop: e.target.scrollTop, name: props.name})}}
			>
				{props.children}
			</div>
		)
	}
}

export default connect(select, scrollActions)(Scroll)



// WEBPACK FOOTER //
// ./src/components/Scroll.js